import React, { useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Typography } from "antd"
import { useOutletContext } from "react-router-dom"

import { VirtualTable } from "@components/Table"
import { computeStatus } from "@components/Transaction"
import {
  indexTransactionsOperation,
  indexFailedTransactionsOperation,
} from "@api/services/transactions"

import useTableSummary from "./helpers/useTableSummary"
import useColumnsConfig from "./helpers/useColumnsConfig"
import getHeaderActions from "./helpers/getHeaderActions"
import useExportColumns from "./helpers/useExportColumns"
import TransactionsTableHeader from "./TransactionsTableHeader"
import useIndexOperationParameters from "./helpers/useIndexOperationParameters"

const { Text } = Typography

const DEFAULT_SORT_COLUMN = "date"
const FAILED_OPERATION_PARAMETERS = {}


const TransactionsTable = ({
  table,
  openImportModal,
  openInvestmentDrawer,
  openTransactionDrawer,
}) => {
  const { failedTransactions = [] } = useOutletContext()

  const [ isFailedOnlyChecked, setIsFailedOnlyChecked ] = useState(false)

  const failedTransactionsCount = failedTransactions.length
  const hasFailedTransactions = failedTransactionsCount > 0
  const shouldShowFailedOnly = isFailedOnlyChecked && hasFailedTransactions

  const {
    updateDateRange,
    operationParameters: dateRangeOperationParameters,
  } = useIndexOperationParameters()

  const indexOperation = shouldShowFailedOnly
    ? indexFailedTransactionsOperation
    : indexTransactionsOperation

  const operationParameters = shouldShowFailedOnly
    ? FAILED_OPERATION_PARAMETERS
    : dateRangeOperationParameters

  const headerRenderTitle = title =>
    shouldShowFailedOnly
      ? <Text>{title}</Text>
      : (
        <TransactionsTableHeader
          title={title}
          updateDateRange={updateDateRange}
        />
      )

  const tableSummary = useTableSummary()

  const size = "small"
  const sticky = true
  const summary = shouldShowFailedOnly
    ? undefined
    : tableSummary
  const bordered = true
  const headerActions = getHeaderActions(
    openImportModal,
    shouldShowFailedOnly,
    setIsFailedOnlyChecked,
    failedTransactionsCount
  )
  const columnsConfig = useColumnsConfig(openInvestmentDrawer, openTransactionDrawer)
  const exportColumns = useExportColumns()
  const exportFileName = "transactions"
  const defaultSortColumn = DEFAULT_SORT_COLUMN

  const filterItemsCallback = useCallback(items =>
    items
      .map(item => ({ ...item, _computedStatus: computeStatus(item) }))
  , [])

  const tableProps = {
    size,
    table,
    sticky,
    summary,
    bordered,
    exportColumns,
    headerActions,
    columnsConfig,
    indexOperation,
    exportFileName,
    headerRenderTitle,
    defaultSortColumn,
    operationParameters,
    filterItemsCallback,
  }

  return (
    <VirtualTable {...tableProps} />
  )
}

TransactionsTable.propTypes = {
  table: PropTypes.shape().isRequired,
  openImportModal: PropTypes.func.isRequired,
  openInvestmentDrawer: PropTypes.func.isRequired,
  openTransactionDrawer: PropTypes.func.isRequired,
}

export default TransactionsTable
